// extracted by css-extract-rspack-plugin
export default {"title":"title-HUQGLm","edit-icon":"edit-icon-yA0PgM","editIcon":"edit-icon-yA0PgM"};